import { render, staticRenderFns } from "./QuotationsList.vue?vue&type=template&id=97178176"
import script from "./QuotationsList.vue?vue&type=script&lang=js"
export * from "./QuotationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports